import React from 'react';
import '../Routes.css';

function Support() {
  return (
    <div className="page__container">
      <h1 className="page__heading">Support</h1>
    </div>
  );
}

export default Support;
